import React from 'react';
import { Modal, ListGroup, Card, ListGroupItem } from 'react-bootstrap';
// import { getTree } from './action/treeAction';
import tableStore from '../../../store/tableStore';
import TableEntity from './tableEntity';

//change this to make it look good and have a list of scroll about tables to choose form
function LoadModal(props) {
    let hide = function () {
        props.hide();
    }

    let tableSto = tableStore.avTables;
    let tableList;
    if (tableSto) {

        tableList = Object.keys(tableSto).map((list) => {
            let tableTitle = tableSto[list].tableName;
            return (
                <TableEntity key={list} id={list} tableTitle={tableTitle} hide={hide} />
            )
        })
        if (tableList.length < 1) {
            tableList = (<ListGroupItem >
                <p className="text-center">No saved tables</p>
            </ListGroupItem>
            );
        }
    }

    return (
        <div>
            <Modal show={props.show} onHide={hide}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        Load an existing node tree
                    </Modal.Title>
                    <Modal.Body>
                        <Card >
                            <Card.Title>
                                Table Name
                            </Card.Title>
                            <ListGroup>
                                {tableList}
                            </ListGroup>
                        </Card>
                    </Modal.Body>
                </Modal.Header>
            </Modal>
        </div>
    )
}

export default LoadModal;



// WEBPACK FOOTER //
// ./src/components/tree/treeHeader/loadTree.js